import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import components from '../components';
const {
  code: Code
} = components;
const renderCode = value => /*#__PURE__*/React.createElement(Code, {
  code: value,
  disableWrapper: true
});
const processDataSummaryValue = (objPropValue, {
  isHtml
}) => {
  let pValue = objPropValue;
  if (isHtml) {
    pValue = Array.isArray(objPropValue) ? objPropValue.map(_ref => {
      let {
          keyField,
          [keyField]: value
        } = _ref,
        otherProps = _objectWithoutProperties(_ref, ["keyField", keyField].map(_toPropertyKey));
      return _objectSpread({
        [keyField]: renderCode(value),
        keyField
      }, otherProps);
    }) : renderCode(objPropValue);
  }
  return pValue;
};
export default processDataSummaryValue;
//# sourceMappingURL=process-data-summary-value.js.map